module.exports = __webpack_public_path__ + "static/img/leftUpOne.927f949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/matrixImg/leftUpOne.png
// module id = BGsH
// module chunks = 0